const DEVICE_ID_STORAGE_KEY = "seevi_web_device_id";

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) return existing;

    const id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? `web-${crypto.randomUUID()}`
        : `web-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

    localStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
    return id;
  } catch {
    return `web-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  }
}

export function getBrowserName(): string {
  const ua = navigator.userAgent;
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("OPR/") || ua.includes("Opera")) return "Opera";
  if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
  if (ua.includes("Firefox")) return "Firefox";
  return "Unknown";
}

export function getDeviceName(): string {
  const browser = getBrowserName();
  const ua = navigator.userAgent;

  if (/iPhone/.test(ua)) return `${browser} on iPhone`;
  if (/iPad/.test(ua)) return `${browser} on iPad`;
  if (/Android/.test(ua)) return `${browser} on Android`;
  if (/Mac OS X|Macintosh/.test(ua)) return `${browser} on macOS`;
  if (/Windows/.test(ua)) return `${browser} on Windows`;
  if (/Linux/.test(ua)) return `${browser} on Linux`;

  return browser;
}

export function buildFcmDevicePayload(fcmToken: string) {
  return {
    fcmToken,
    deviceId: getOrCreateDeviceId(),
    deviceName: getDeviceName(),
    browser: getBrowserName(),
    platform: "web",
    userAgent: navigator.userAgent,
  };
}
